module.exports = __webpack_public_path__ + "static/media/fuji.2c2b07aa.JPG";